module.exports = __webpack_public_path__ + "static/media/project-region-right.4e106a81.jpg";